function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLittleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#fefffe",
    d: "M 130.5,4.5 C 132.833,4.5 135.167,4.5 137.5,4.5C 138.602,20.462 132.602,32.962 119.5,42C 114.533,44.9335 109.199,46.7668 103.5,47.5C 101.055,46.7221 99.722,45.0554 99.5,42.5C 101.84,23.173 112.173,10.5063 130.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#fefffe",
    d: "M 68.5,47.5 C 72.5092,47.8583 76.5092,48.3583 80.5,49C 87.5776,51.5825 94.7443,53.7491 102,55.5C 110.522,53.1606 119.022,50.6606 127.5,48C 144.777,45.5572 158.943,51.0572 170,64.5C 166.606,68.9145 162.606,73.2479 158,77.5C 146.933,97.9297 149.767,116.096 166.5,132C 168.67,133.586 171.004,134.92 173.5,136C 174.059,136.725 174.392,137.558 174.5,138.5C 169.292,155.773 159.958,170.273 146.5,182C 140.922,185.301 134.922,186.301 128.5,185C 120.893,182.02 113.06,179.853 105,178.5C 96.8396,179.498 89.0062,181.665 81.5,185C 77.1667,185.667 72.8333,185.667 68.5,185C 57.3405,178.172 48.5071,169.005 42,157.5C 29.0465,135.027 24.7132,111.027 29,85.5C 34.0179,64.1203 47.1846,51.4537 68.5,47.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLittleLogo);
export default __webpack_public_path__ + "static/media/apple_little_logo.3715ad65870c19cada399c60b35a2746.svg";
export { ForwardRef as ReactComponent };